import React from 'react';
import ReactDOM from 'react-dom';
import GlassDataTable from '../../components/GlassDataTable';
import './recurring-view.css';
import '../../styles/page-common.css';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DateFilter from '../../components/DateFilter';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import { Pie } from "react-chartjs-2";
import moment from 'moment';
import Recurring from '../../components/recurring';
import { calculateInvoiceTotals, calcNextRunDate, calculateLineItemTotals, format } from '../../helpers/invoiceNumber';
import queryString from 'query-string';

class HomeView extends React.Component {

  state = {
    modal: false,
    pdfModal: false,
    newInvoice: {},
    newLineItem: {},
    rankType: 'all',
    type: 'all',
    showAdd: false
  }

  componentDidMount() {
    let params = queryString.parse(this.props.location.search)
    const type = params.type || 'all';
    if (params.type) {
      this.setState({ type: params.type });
    }
    // Only fetch once a company is selected — componentDidUpdate picks it up
    // on a hard refresh once companies have rehydrated.
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetRecurring(type);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let params = queryString.parse(this.props.location.search);

    // Company became available (e.g. hard refresh) — load now.
    if (
      this.props.selectedCompanyId &&
      this.props.selectedCompanyId !== prevProps.selectedCompanyId
    ) {
      this.props.dispatchGetRecurring(this.state.type || params.type || 'all');
    }

    if (params.type) {
      if (this.state.type != params.type) {
        this.props.dispatchGetRecurring(params.type);
        this.setState({
          type: params.type,
        })
      }
    }
  }

  scrollToTop = () => window.scrollTo(0, 0);

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd })
  }

  getDataFromURL = (url, user) => new Promise((resolve, reject) => {
    setTimeout(() => {
      let req = {
        headers: {
          username: user.username,
          token: user.token,
          AUTHORIZATION: user.token
        },
        method: 'GET'
      }

      fetch(url, req)
        .then(response => response.blob())
        .then(data => {
          resolve(data)
        });
    });
  }, 2000);

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    var Invoices = [];
    let methodPaids = {};
    let Total = 0;
    let VAT = 0;

    if (this.props.recurring.recurring.length > 0) {
      Invoices = this.props.recurring.recurring.map(p => {

        let { total, preTotal, discount, tax, tax2 } = calculateInvoiceTotals(p.descriptions, p.discount);

        Total += (preTotal - discount);
        VAT += (tax + tax2);

        if (p.descriptions) {
          p.descriptions.forEach(element => {
            if (!methodPaids[element.category]) methodPaids[element.category] = 0;

            let { i_total } = calculateLineItemTotals(element);
            methodPaids[element.category] += i_total;
          });
        }

        console.log('methodPaids', methodPaids)

        return {
          name: p.client ? (p.client.name + ' ' + (p.client.surname ? p.client.surname : '')) : p.to,
          invoiceDate: calcNextRunDate(p).format('YYYY-MM-DD'),
          lastRunDate: p.lastRunDate ? moment(p.lastRunDate).format('YYYY-MM-DD') : '',
          total: format(total),
          active: !!p.active ? 'True' : 'False',
          recurringType: p.recurringType,
          view: <button type='button' style={{ background: 'rgba(13,161,178,0.12)', border: '1px solid rgba(13,161,178,0.25)', color: 'var(--primary-dark)', borderRadius: 8, padding: '5px 14px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }} onClick={() => {
              this.props.dispatchGetRecurringItem(this.state.type, p._id, loaded);
              let updateshowAdd = this.updateshowAdd;
              function loaded(error) {
                if (!error) updateshowAdd(true);
              }
            }}>
              View
            </button>,
        }
      });
    }

    let s = [];
    Object.keys(methodPaids).map(i =>
      s.push({
        name: i,
        value: methodPaids[i]
      })
    );

    s = s.sort((a, b) => a.value > b.value ? -1 : 1);
    let c = 0;
    let y = {
      Other: 0
    };

    s.forEach((e, i) => {
      if (i > 4) y.Other += e.value;
      else y[e.name] = e.value;
    });

    const data = {
      columns: [
        {
          label: 'Next Run',
          field: 'invoiceDate',
          sort: 'asc'
        },
        {
          label: 'Last Run',
          field: 'lastRunDate',
          sort: 'asc'
        },
        {
          label: 'Frequency',
          field: 'recurringType',
          sort: 'asc'
        },
        {
          label: 'Amount',
          field: 'total',
          sort: 'asc'
        },
        {
          label: 'Client',
          field: 'name',
          sort: 'asc'
        },
        {
          label: 'Active',
          field: 'active',
          sort: 'asc'
        },
        {
          label: '',
          field: 'view',
          sort: 'asc'
        }
      ],
      rows: Invoices.sort(function (a, b) {
        if (a.startDate < b.startDate) return 1; else return -1;
      })
    };
    methodPaids = y;
    var dataPie = {
      labels: Object.keys(methodPaids),
      datasets: [
        {
          data: Object.keys(methodPaids).map(i => methodPaids[i]),
          backgroundColor: [
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD",
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD",
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD",
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD"
          ],
          hoverBackgroundColor: [
            "#FF5A5E",
            "#5AD3D1",
            "#FFC870",
            "#A8B3C5",
            "#616774",
            "#DA92DB",
            "#FF5A5E",
            "#5AD3D1",
            "#FFC870",
            "#A8B3C5",
            "#616774",
            "#DA92DB",
            "#FF5A5E",
            "#5AD3D1",
            "#FFC870",
            "#A8B3C5",
            "#616774",
            "#DA92DB",
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD"
          ]
        }
      ]
    };

    return (
      <div className="content-wrapper" style={{ ['--list-accent']: '#0DA1B2', ['--list-accent-dark']: '#067886' }}>
        {/* Hero band */}
        <div className="gl-hero" style={{ margin: '0 6px 14px' }}>
          <div className="gl-hero-row">
            <div>
              <div className="gl-hero-title">Recurring {this.state.type !== 'all' ? this.state.type.charAt(0).toUpperCase() + this.state.type.slice(1) : ''}</div>
              <div className="gl-hero-sub">Scheduled invoices, expenses &amp; appointments</div>
            </div>
          </div>
        </div>

        <div style={{ padding: '0 6px 20px' }}>
        <SpinnerView showSpinner={this.props.recurring.loading} />

        {this.state.showAdd && ReactDOM.createPortal(
          <div
            onClick={(e) => { if (e.target === e.currentTarget) this.updateshowAdd(false); }}
            style={{ position: 'fixed', inset: 0, zIndex: 1200, background: 'rgba(15,31,46,0.45)', WebkitBackdropFilter: 'blur(4px)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 16px', overflowY: 'auto' }}
          >
            <div style={{ width: '100%', maxWidth: 1000, margin: 'auto', background: '#fff', borderRadius: 16, boxShadow: '0 24px 60px rgba(15,31,46,0.30)', overflow: 'hidden' }}>
              <div style={{ background: 'rgba(255,255,255,0.55)', WebkitBackdropFilter: 'blur(22px) saturate(1.4)', backdropFilter: 'blur(22px) saturate(1.4)', borderBottom: '1px solid rgba(15,31,46,0.08)', padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ color: 'var(--text)', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 18 }}>
                  Recurring {this.state.type !== 'all' ? this.state.type.charAt(0).toUpperCase() + this.state.type.slice(1) : ''}
                </span>
                <button type="button" onClick={() => this.updateshowAdd(false)} aria-label="Close"
                  style={{ background: 'rgba(15,31,46,0.06)', border: 'none', color: 'var(--text-secondary)', width: 34, height: 34, borderRadius: 9, cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
              </div>
              <div style={{ padding: '20px 22px' }}>
                <Recurring updateshowAdd={this.updateshowAdd} type={this.state.type} />
              </div>
            </div>
          </div>,
          document.body
        )}




        {/* Toolbar */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '12px 20px',
          background: 'white',
          borderRadius: 8,
          marginBottom: 16,
          flexWrap: 'wrap'
        }}>
          {/* New Button */}
          <button
            type="button"
            onClick={() => {
              this.props.dispatchClearRecurringItem();
              this.updateshowAdd(true);
            }}
            style={{
              background: '#0DA1B2',
              border: 'none',
              color: 'white',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 500,
              fontSize: 13
            }}
          >
            <i className="fas fa-plus"></i> New
          </button>

          <div style={{ width: 1, height: 24, background: '#e0e0e0', margin: '0 8px' }}></div>

          {/* Type Filter Buttons */}
          <Link
            to="/recurring?type=invoices"
            style={{
              background: this.state.type === 'invoices' ? '#17a2b8' : '#f5f5f5',
              border: 'none',
              color: this.state.type === 'invoices' ? 'white' : '#666',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 500,
              fontSize: 13,
              textDecoration: 'none'
            }}
          >
            <i className="fas fa-file-invoice"></i> Invoices
          </Link>
          <Link
            to="/recurring?type=expenses"
            style={{
              background: this.state.type === 'expenses' ? '#17a2b8' : '#f5f5f5',
              border: 'none',
              color: this.state.type === 'expenses' ? 'white' : '#666',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 500,
              fontSize: 13,
              textDecoration: 'none'
            }}
          >
            <i className="fas fa-receipt"></i> Expenses
          </Link>
          <Link
            to="/recurring?type=calender"
            style={{
              background: this.state.type === 'calender' ? '#17a2b8' : '#f5f5f5',
              border: 'none',
              color: this.state.type === 'calender' ? 'white' : '#666',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 500,
              fontSize: 13,
              textDecoration: 'none'
            }}
          >
            <i className="fas fa-calendar-alt"></i> Appointments
          </Link>

          <div style={{ width: 1, height: 24, background: '#e0e0e0', margin: '0 8px' }}></div>

          {/* Export Buttons */}
          <DownloadLink
            label={<><i className="fas fa-download"></i> Export CSV</>}
            style={{
              background: '#f5f5f5',
              border: 'none',
              color: '#666',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 500,
              fontSize: 13,
              textDecoration: 'none'
            }}
            filename={"recurring.csv"}
            exportFile={() => Promise.resolve(this.getDataFromURL(urls.getRecurring(this.props.selectedCompanyId, this.state.type) + '/export', this.props.authUser))}
          />
          <DownloadLink
            label={<><i className="fas fa-file-csv"></i> Sage CSV</>}
            style={{
              background: '#f5f5f5',
              border: 'none',
              color: '#666',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 500,
              fontSize: 13,
              textDecoration: 'none'
            }}
            filename={"recurring_sage.csv"}
            exportFile={() => Promise.resolve(this.getDataFromURL(urls.getRecurring(this.props.selectedCompanyId, this.state.type) + '/exportSage', this.props.authUser))}
          />
        </div>

        <div className='row'>
          <div className='col-md-3 col-sm-3 col-3'>
            <div className="info-box bg-gradient-danger">
              <span className="info-box-icon"><i className="fas fa-dollar-sign"></i></span>

              <div className="info-box-content">
                <span className="info-box-text">Total (Excl)</span>
                <span className="info-box-number">R {format(Total)}</span>

                <div className="progress">
                  <div className="progress-bar" ></div>
                </div>
                <span className="progress-description">

                </span>
              </div>
            </div>
          </div>
          <div className='col-md-3 col-sm-3 col-3'>
            <div className="info-box bg-gradient-danger">
              <span className="info-box-icon"><i className="fas fa-dollar-sign"></i></span>

              <div className="info-box-content">
                <span className="info-box-text">VAT</span>
                <span className="info-box-number">R {format(VAT)}</span>

                <div className="progress">
                  <div className="progress-bar" ></div>
                </div>
                <span className="progress-description">

                </span>
              </div>
            </div>
          </div>

        </div>

        <div className="col-md-4 card card-danger  collapsed-card">
          <div className="card-header">
            <h3 className="card-title">Top 5 Line Items</h3>

            <div className="card-tools">
              <button type="button" className="btn btn-tool" data-card-widget="collapse">
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <div className="card-body" style={{ Display: 'none' }} >
            <div className="chartjs-size-monitor"><div className="chartjs-size-monitor-expand"><div className=""></div></div><div className="chartjs-size-monitor-shrink"><div className=""></div></div></div>
            <Pie data={dataPie} className={'pieChart'} options={{ responsive: true }} />
          </div>
        </div>

        <GlassDataTable data={data} />
        </div>
      </div >
    );
  }
}

export default HomeView;
